var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#BEC0C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAFZUlEQVR4nO2c22tdRRSHvwR6Yk4SsdY28VHQRrBYqFWrplRBIoji5Vn/g8T2TxAR1Adtm+hrKRURAyoVWoMUL8FLW/FNGwtSsEYbE23F1tqkmPiw9inHZK+9J2df1uzjfDAv09M9v1mZs/aaNWsOBAKBQCAQCAQCgYCndBiP3wMMAduAQeB2YCOwPvo3gL+AC8AccDpq3wCfA5dL1lspNgF7gClgAVhusS1Ez9gdPTMQsRM4DFyldeNqbTF69lBps/GQXcBn5G9crX2K/FH/NwwAh4AlyjNyc5sA+gufpTFPA+exMXBzOw88WfBcTagB+1nbKv4FeAsYBYaBW5GoY13U1kd9w8Bz0WfPreH5S8De6FltQS/wEW6TnwP2AXdlGG878keddxxzMtJYaTYAJ0mf7I/ACNCd49jdyLfhrMP4JyKtlaQOfEnyBBeR1VfkiuoGngeupGg5WbCOQqiR7i6+A+4oUdMW4FSKpkkq5rP3kzyht5EVXzY9SHiXpO01A10t8TjJ0cXrQKeZOsnjvBqjqzkaecpMnSMDJMfJY3bSVjGOrvN3PM+TvEmyu7BcySvpJNmNHDRTlsIudJfxLTY+OY1eYBrdhXiZjNISRFcoN7pYK3eip2U/NtQVy33oX8EXDHW58hK6fq9W9WH0HV+eu72i6AFmiJ/D+4a6/sMmZIcXJ3LEUNda2YO+e91oqOsamsA5qrGaG9TRE1GjhrquMUW8uH2WolpkjPi5fGIpCsS3aW/sbYa6WuVu9MjJ9Ns5HCNqGUnaV5EOYJb4OT1cxICuO7jtSr938acjSW4iy2GEiquhNyv9J/ISYsBxpX+wiMFcDa0NfjovIQZo2k0NPaD0/5CXEAM07TcXMZiroa9X+v/IS4gBF5T+vlJVrEAL7WqWojJSQw/xcsenvHHZaJW0hVTYuhr6ktJfudPkJjQXoc01E66G/lPpvyEvIQZo2k0NPav035aXEAM07T8VMZiroUuNOUtC036miMGyGnpHXkIM0LRPl6piBY8QHwrNYn8PphWSkkoP2smSZLkWS2sJJ5+5F/2UpSfh/7WMq+u4jJ5AejYnLWXyjNI/hdwCM2U3+lGWj7UcGnXgNzw++0w6nPXirM2RpMPZQhJKraCVG5ylGqu6B/iZ+Dm8Y6hrFUPoBSgvGupy5WV0/V4V0IDc49OyXlvsZKWyFT1yOmaoS2UnepHjKQoKjzLSB3xPvOYlPN54HUL/Ck7gV/q1E3gXXe9BM2UO9JNciD5uJ20Vb6DrnAduspPmxmNU/2pFZW7V7kWfSMONWBwO9JHsLpap0GUhkCtkkyRPaBopAi+LregvvuZ2BOgqUVdm6sAXJE+qcaGzyBPmOm4XOpvbJHBdgZpyZwOSdEqb2AySM8lzF1lHttXajq/tVnYv6W6k+W0/BtxDa/nsDiTVOY6eIPLK2Hkn7dcBryArzPXZvyIFh8eRk5wzyB+ika7sRSrxb0F+3GoH8BDu9wOXkRruQeDRhM8dRX5nZMHxuV7wBHJZMutKy9rmIy0gK/ZIyucr50YAbkRegP9gY+QJVt9JqaFnICv7gmwwhNRRl2XgYyTnLtp2ZTe4H7liph0eZGmLSD7ZNdXZ9sYGyS2MIi/AtcS8K9tVZPWO0NrJSKnGti4V6AYeQE7SNyNRRT9SrtWL6LuElKTNIBHJNPAV8DXZD1K7gPdIjkY+RH5uolLRiI+09QvSN4KxS6QGfEAwdikEY5dIMHaJBGOXSBeSaEoy9lEqvqnxBRdjV/HXHbwkzdgXsd/4tQ1Jxv4bv+pYKo9m7AOWotqVLsQnX0RW8gGqfdfSezoIfjkQCAQCgUAgECicfwE2iPyzmRknMwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.1f96e24dddb6dad536b8bdf8b82c6f2e.svg";
export { ForwardRef as ReactComponent };